import QRCode from 'react-qr-code';
import { QrCodeIcon } from 'shared/images/icons';
import { Lang } from 'shared/constants';
import { STORES_LINKS } from 'shared/constants/application.constants';
import styles from './mobile-qr-code.module.scss';
import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { faSparkles } from '@fortawesome/pro-regular-svg-icons';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from 'antd';

/**
 * @typedef {object} MobileQRCodeProps
 * @property {string} url
 * @property {object} lang
 * @exports MobileQRCodeProps
 */

/**
 * Mobile QR Code component for marketing the mobile app
 * @param {MobileQRCodeProps} props
 * @returns {JSX.Element}
 */
export const MobileQRCode = forwardRef(function MobileQRCode(
  { url = STORES_LINKS.mobile, lang = Lang.HEADER },
  ref,
) {
  const [open, setOpen] = useState(false);

  const openDialog = () => {
    setOpen(true);
  };

  const closeDialog = e => {
    if (e) {
      e.stopPropagation?.();
    }
    setOpen(false);
  };

  useImperativeHandle(ref, () => ({
    openDialog,
  }));

  return (
    <>
      <div className={styles.qrContainer}>
        <img className={styles.qrIcon} src={QrCodeIcon} alt="" />
        <p className={styles.clickAndScan}>{lang.CLICK_AND_SCAN}</p>
        <FontAwesomeIcon icon={faSparkles} beat size="1x" />
      </div>
      <Modal
        open={open}
        onCancel={closeDialog}
        footer={null}
        title={null}
        closable
        keyboard
        autoFocus
        mask={{ closable: true }}
        getContainer={() => document.body}
        closeIcon={<FontAwesomeIcon icon={faXmark} className={styles.closeIcon} />}
        className={styles.modalContent}
        rootClassName={styles.modal}
        width="100%"
        wrapProps={{ 'aria-modal': true, role: 'dialog' }}
        classNames={{
          mask: styles.modalMask,
        }}>
        <div className={styles.modalBody}>
          <div className={styles.qrCode}>
            <QRCode className={styles.qrLarge} value={url} />
          </div>
          <p>{lang.SCAN_TO_DOWNLOAD_MOBILE_APP}</p>
        </div>
      </Modal>
    </>
  );
});
